/*jslint browser: true */
/*global window:false, ko:false, $:false, AdminPhoto:false, overlayMedia:false */

;(function () {
    "use strict";

    window.MarketItemTagsViewModel = function (options, $form) {

        window.ObjectTagsViewModel.call(this, options);
        var model = this;

        var obj;
        obj = new TagObject();
        obj.id = options.item_id;
        obj.tags = options.item_tags || [];
        model.object(obj);
        model.activeTags(obj.tags);

        if (Boolean($form)) {
            model.activeTags.subscribe(function() {
                $form.trigger('MarketItemTags::changed');
            });
        }
    };

    window.MarketItemTagsViewModel.prototype = window.ObjectTagsViewModel;
})();